module.exports = __webpack_public_path__ + "media/images/club-logo/2-21f40222e5a6645904a67de2a013262a.png";